import { render, staticRenderFns } from "./SCard.vue?vue&type=template&id=1d5e37e5"
import script from "./SCard.vue?vue&type=script&lang=js"
export * from "./SCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports